import React from 'react';
import { Quote } from 'lucide-react';

const AboutSection = () => {
  return (
    <section className="py-24 bg-gradient-to-b from-white to-[#F7F9FB]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Text Content */}
          <div>
            <h2 className="text-5xl font-bold text-[#0B0F14] mb-6">
              More Than Transportation
            </h2>
            <div className="space-y-6 text-lg text-[#5F6B7A] leading-relaxed">
              <p>
                At <span className="font-semibold text-[#0077BE]">No Limit 365 Transportation</span>, 
                we provide specialized 10-passenger vans as an alternative to traditional school buses. 
                Our smaller, more comfortable vehicles offer individualized attention and support for students with unique needs.
              </p>
              <p>
                Every ride is an opportunity to support, stabilize, and uplift. We go beyond 
                logistics—recognizing that each child carries experiences that shape their 
                behavior, emotions, and needs.
              </p>
              <p>
                We don't just transport students.<br />
                <span className="text-2xl font-bold text-[#00B4D8]">We support their journey.</span>
              </p>
            </div>
          </div>

          {/* Visual Card with Image */}
          <div className="relative">
            <div className="rounded-3xl overflow-hidden shadow-2xl">
              <img 
                src="https://customer-assets.emergentagent.com/job_trusted-journeys-co/artifacts/mpfshf1u_1.webp"
                alt="NO LIMIT 365 Mercedes Sprinter 10-passenger van"
                className="w-full h-[400px] object-cover"
              />
            </div>
            
            {/* Floating Glass Card */}
            <div className="absolute -bottom-8 -left-8 right-8 p-8 rounded-2xl backdrop-blur-xl bg-white/90 border border-white/50 shadow-2xl">
              <Quote className="w-8 h-8 text-[#0077BE] mb-3" />
              <p className="text-xl font-bold text-[#00B4D8] leading-relaxed">
                "Behavior is communication. We train our staff to understand it."
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
